export class RequestDcmCodes {
        dcmCodes: string[];
}
